interface PageHeroProps {
  title: string;
  subtitle?: string;
}

const PageHero = ({ title, subtitle }: PageHeroProps) => {
  return (
    <section className="bg-primary text-primary-foreground pt-32 pb-16 md:pt-40 md:pb-20">
      <div className="container-wide">
        <h1 className="heading-display animate-fade-up">{title}</h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-primary-foreground/80 mt-4 max-w-2xl animate-fade-up delay-100">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
